import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { useLoading } from './store';

function Loading({ children }) {
  const { isLoading, isBlockedScreen } = useLoading();
  return (
    <div className="relative h-full">
      {isLoading && (
        <div className="z-50 absolute w-full top-0 left-0">
          <LinearProgress />
        </div>
      )}

      <div className={`${isBlockedScreen ? 'opacity-80' : ''} px-2 py-4 h-full`}>{children}</div>
    </div>
  );
}

export default Loading;
